import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, useLocation } from "react-router-dom";
import "@/index.css";
import { AppRoutes } from "@/routes";
import AuthCallback from "@/pages/AuthCallback";
import { AuthProvider } from "@/context/AuthContext";
import { ChatWidget } from "@/components/ChatWidget";

// Detect the Emergent OAuth callback (session_id in URL fragment) BEFORE routing.
// Reads from useLocation().hash so it reacts to history.replaceState.
function AuthGate({ children }) {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return children;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <AuthGate>
          <AppRoutes />
          <ChatWidget />
        </AuthGate>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
